import CommonFooter from 'components/CommonFooter'
import React from 'react'
import {Card} from 'antd'
import {Switch,Route} from 'react-router-dom'
import './register.less'
import QueryCom from './query'
import EditUserInfoCom from './edit_userInfo'
import SuccessCom from './success'

const RegisterCom = () => {
  return (
    <>
      <div className="wrap">
        <div
          className="wrap-mask"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/login-bg.png)`,
          }}
        >
          <div className="logo">
            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="logo" />
          </div>
          <Card className='register-form-card'>
            <Switch>
              <Route exact path='/register/query' component={QueryCom}></Route>
              <Route exact path='/register/edit_userInfo' component={EditUserInfoCom}></Route>
              <Route exact path='/register/success' component={SuccessCom}></Route>
            </Switch>
          </Card>
          <div className="footer-container">
            <CommonFooter color="blue" />
          </div>
        </div>
      </div>
    </>
  )
}

export default RegisterCom
